function findUpperLetter (word: string) {
    return word.replace(/([A-Z])/g, ' $1').trim();
}
function transformWord (word:string) {
    return word.charAt(0).toUpperCase() + word.substr(1);
}

function byUnderline (words:string) {
    return words.split('_').map((word:string) => {
        return transformWord(word);
    }).join(' ');
}

function capitalizeFirstLetter(str: string):string {
    const checkUnderline = str.indexOf('_') !== -1;
    
    if(checkUnderline) {
        if(str !== str.toUpperCase()){
            const strLowerCase = str.toLowerCase();
            return byUnderline(strLowerCase);
        } else {
            return str;
        }
    } else {
        return transformWord(findUpperLetter(str))
    }
}

export default capitalizeFirstLetter;